// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3qxHU","actionsCol":"EnrolledClinics_actionsCol__A8rPU"};